import { css } from "glamor";
import React from "react";
import { colors, spacing } from "../library/theme";

const countClass = css({
  marginTop: spacing.xs,
  textAlign: "right",
  color: colors.greyDarker,
  fontSize: 13,
});

// Fica oculto sem termo de busca (o reducer volta ao estado inicial, com
// totalCount 0) e quando a busca não encontra nada — nesse caso quem fala é o
// QuestionSearchEmpty.
export default function QuestionSearchResultCount({ totalCount }) {
  if (!totalCount) return null;

  return (
    <div className={countClass}>
      {totalCount === 1
        ? "1 questão encontrada"
        : `${totalCount} questões encontradas`}
    </div>
  );
}
